module.exports = __webpack_public_path__ + "static/feature-time-d6be3bb825d3d278c43d274a7a02e939.svg";